import React from "react";

function Footer({ className }) {
  return (
    <div
      className={`container-fluid shadow pt-3 pb-1 w-100 bg-white ${className}`}
      style={{ zIndex: 1 }}
    >
      <p className="text-center">
        Crafted with ❤️ by{" "}
        <a
          href="https://creatifastudio.com"
          className="text-dark text-decoration-none"
        >
          CreatifaStudio
        </a>
      </p>
    </div>
  );
}

export default Footer;
